import React, { useEffect, useState } from 'react';
import {
  ButtonPrimary,
  ButtonIcon,
} from 'kubra-ux/dist/elements/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export interface TitleBarProps{
  title?: string;
  subtitle?: string;
  deviceType?: string;
}

const onClickHandler = (): void => {
  window.location.href = `https://kubra.io/stormcenter/views/${process.env.REACT_APP_INSTANCE_VIEW_ID}`;
};

const TitleBar: React.FunctionComponent<TitleBarProps> = (props: TitleBarProps): JSX.Element => {
  const { title, subtitle, deviceType } = props;
  const [mobileTitleOpened, setMobileTitleOpened] = useState(false);

  useEffect((): void => {
    if (deviceType !== 'mobile') {
      setMobileTitleOpened(false);
    }
  }, [deviceType]);

  return (
    <div className={'title-bar'}>
      <div className={'title-bar-inner'}>
        {deviceType === 'mobile' && <ButtonPrimary classNames={'return-button'} onClick={(): void => onClickHandler()}><span>Return To Map</span></ButtonPrimary>}
        {deviceType !== 'mobile'
          ? <div style={{ paddingLeft: '10px' }}>
          <h1>{title}</h1>
          <p>{subtitle}</p>
        </div>
          : <div>
            {title !== '' && subtitle !== ''
            && <div className={'mobile-title-button'}>
              <ButtonIcon onClick={ (): void => setMobileTitleOpened(true) }>
                <FontAwesomeIcon icon={['fas', 'info']}/>
              </ButtonIcon>
            </div>
          }
          </div>
        }
        {mobileTitleOpened && title !== '' && subtitle !== ''
        && <div className={'mobile-title-dialog'}>
          <div className={'dialog-title'}>
            <h2>{title}</h2>
            <button onClick={(): void => setMobileTitleOpened(false)}>
                <FontAwesomeIcon icon={['fas', 'times']}/>
            </button>
          </div>
          <div className={'dialog-body'}>
            <span>{subtitle}</span>
          </div>
        </div>}
        {mobileTitleOpened && title !== '' && subtitle !== ''
        && <div className={'dialog-backdrop'}
                onClick={ (): void => setMobileTitleOpened(false) }
                onKeyDown={(target: React.KeyboardEvent<HTMLDivElement>): void => target.currentTarget.click()}
                role={'button'}
                tabIndex={-1}>
          &nbsp;
        </div>}
      </div>
    </div>
  );
};

const defaultProps: Partial<TitleBarProps> = {
  title: '',
  subtitle: '',
};

TitleBar.defaultProps = defaultProps;

export default TitleBar;
